module.exports = __webpack_public_path__ + "static/img/gswkwx-details.fa11c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gswkwx-details.png
// module id = sNSL
// module chunks = 0